module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.7165/assets/images/gemini-connector.jpg"